"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const constants_1 = require("../../theme/constants");
exports.TagStyled = styled.div `
&.octo {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  padding: 0.25em 0.5em;
  border-radius: 0.625em;
  background-color: ${design_system_1.theme.colors.marine[5]};
  color: ${design_system_1.theme.colors.marine[100]};
  font-weight: 600;
  text-transform: uppercase;
  cursor: pointer;
  transition: ${constants_1.transitions.fast};
  transition-property: background-color, color;

  span {
    font-size: 0.875em;
  }

  &:hover {
    background-color: ${design_system_1.theme.colors.marine[100]};
    color: ${design_system_1.theme.colors.marine[5]};
  }
}
`;
//# sourceMappingURL=Tag.styled.js.map